import React from 'react';
import { GlobeIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-line bg-white px-4 py-12" data-id="element-159" data-mp="3gfiu2hdxs9dl">
      <div className="mx-auto max-w-4xl text-center" data-id="element-160" data-mp="32nulgo2wc31d">
        <p className="text-lg font-black uppercase tracking-tight text-primary" data-id="element-161" data-mp="32p5qer82vgu2">
          🏋️ Combo Completo Powerlifting Pro 2026
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-162" data-mp="3uf0nja26gata">
          El sistema de periodización y técnica para entrenadores de powerlifting de todos los
          niveles en Argentina.
        </p>
        <p className="mt-2 text-sm font-semibold text-slate-500" data-id="element-163" data-mp="36czunggsbik">
          Porque entrenar fuerza no debería ser un misterio. Debería ser un SISTEMA.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-slate-600 sm:flex-row sm:gap-6" data-id="element-164" data-mp="3qbvmlbxqwh6r">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="mailto:compradigitalyaa@gmail.com" data-id="element-165" data-mp="2ey9zrxfcyroe">
            <MailIcon className="h-4 w-4" data-id="element-166" data-mp="3lbdc0r0ka5kr" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="https://www.compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-167" data-mp="3gcjzp1x0gkm6">
            <GlobeIcon className="h-4 w-4" data-id="element-168" data-mp="81ywcgswhu2x" /> www.compradigitalya.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-primary" href="https://instagram.com/compradigitalya" target="_blank" rel="noopener noreferrer" data-id="element-169" data-mp="34gyblgf8z9p">
            <InstagramIcon className="h-4 w-4" data-id="element-170" data-mp="cw33b0262240" /> @compradigitalya
          </a>
        </div>
        <div className="mt-7 border-t border-line pt-6" data-id="element-171" data-mp="qrfba95c1p2v">
          <p className="text-base font-black text-ink" data-id="element-172" data-mp="msy27k2cq4it">
            🏋️ “El próximo ciclo puede ser diferente.”
          </p>
          <p className="mt-1 text-sm font-semibold italic text-primary" data-id="element-173" data-mp="twxuhinrnqdj">
            “Finalmente un programa que FUNCIONA.”
          </p>
          <p className="mt-5 text-xs font-semibold text-slate-400" data-id="element-174" data-mp="13tajw4ca3i2h">
            © CompraDigitalYa™ 2026 — Todos los derechos reservados.
            <br data-id="element-175" data-mp="18l2cekezvxv9" />
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}